import React from 'react';
import './Sub-services.css';
import retie from './assets/retie.png';

const Retie = () => {
  return (
    <div className="containerSer">
      <h2>Trámites de certificaciones RETIE</h2>
      <p>
        La certificación RETIE (Reglamento Técnico de Instalaciones Eléctricas)
        es un requisito legal obligatorio en Colombia para asegurar que las
        instalaciones eléctricas cumplan con los estándares de seguridad,
        eficiencia y calidad.
      </p>
      <div className="image">
        <img
          src={retie}
          alt="Imagen sobre la certificación retie"
        />
      </div>

      <p>
        Ofrecemos el servicio de tramites de certificación RETIE para
        instalaciones eléctricas residenciales, comerciales e industriales
        gestionando la documentación, organización y presentación técnica
        requerida, así como de coordinar la visita del organismo certificador
        acreditado; este servicio incluye: revisión técnica previa de la
        instalación, elaboración de planos y memorias de cálculo (si aplica);
        recolección y organización de la documentación exigida, coordinación con
        el organismo certificador; acompañamiento durante el proceso de
        inspección, seguimiento hasta la obtención del certificado RETIE.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Cumplimiento de la normatividad legal vigente</li>
        <li>Mayor seguridad en tus instalaciones eléctricas</li>
        <li>
          Requisito para legalizar sistemas ante operadores de red y entes de
          control
        </li>
        <li>Evitar sanciones y retrasos por instalaciones no certificadas</li>
      </ul>
    </div>
  );
};

export default Retie;
